import type { ReactElement } from 'react'

import './styles.scss'

const SkeletonLoader = (): ReactElement => {
  return <div className="skeleton-loader-component" />
}

export default SkeletonLoader
